import { useDrop } from 'react-dnd'

import type { DND_TYPES_ACCEPT, DragItemType } from '../constant'

const handleDropCollect = monitor => {
  const item = monitor.getItem()
  const isOver = monitor.isOver()
  return {
    isDragging: !!monitor.getItem(),
    isOver,
    item
  }
}

type DropItem = void

type Params = {
  accept: DND_TYPES_ACCEPT
}

export type CollectType = {
  isDragging: boolean
  isOver: boolean
  item: DragItemType
}

export const useBaseDrop = ({ accept }: Params) => {
  const [data, ref] = useDrop<DragItemType, DropItem, CollectType>({
    accept,
    canDrop() {
      return false
    },
    collect: handleDropCollect
  })

  return [data, ref] as const
}
